module.exports = __webpack_public_path__ + "static/media/WorkTables2.f1c58733.jpg";